var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5034 0C5.88683 0 0.5 5.38713 0.5 12.0027C0.5 18.6197 5.88683 24 12.5034 24C19.12 24 24.5 18.6183 24.5 12.0027C24.5 5.38577 19.1186 0 12.5034 0ZM12.5034 2.00022C18.0388 2.00022 22.4998 6.4683 22.4998 12.0027C22.4998 17.5384 18.0388 21.9996 12.5034 21.9996C6.968 21.9996 2.50153 17.5384 2.50153 12.0027C2.50153 6.46694 6.96936 2.00022 12.5034 2.00022ZM17.4799 7.18266L17.4812 7.18133C17.2142 7.20125 16.9672 7.3261 16.7932 7.5293L10.9243 14.3428L8.17249 11.5005H8.17116C7.98523 11.3106 7.73155 11.2016 7.46463 11.199C7.19901 11.1963 6.94267 11.2999 6.75275 11.4872C6.36098 11.8724 6.35432 12.5033 6.73814 12.8977L10.2455 16.5209C10.4407 16.7227 10.713 16.833 10.9932 16.825C11.2748 16.817 11.5391 16.6909 11.7223 16.4784L18.3069 8.82949V8.82816C18.6668 8.4111 18.6217 7.77892 18.2033 7.41766C18.0028 7.24765 17.7425 7.16265 17.4809 7.18257L17.4799 7.18266Z",
    fill: "#082980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.98c430a49e212105ad2cdec1e6036148.svg";
export { ForwardRef as ReactComponent };